// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__17XxX","disabled":"FileBtn_disabled__1d_r7","warn":"FileBtn_warn__1pHA0","fade":"FileBtn_fade__2N3fn"};